import { Alert, Button, Container, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { Helmet } from 'react-helmet-async';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';

import { useGetQuestionnaireFillQuery } from '../../slices/apis/questionnaireFillApi';

export default function QuestionnaireSubmitted() {
	const location = useLocation();
	const navigate = useNavigate();
	const { token } = useParams() as { token: string };
	const { data, isLoading, isError, error } = useGetQuestionnaireFillQuery(token);
	const justSubmitted = location.state && typeof location.state === 'object' && 'justSubmitted' in location.state
		? location.state.justSubmitted === true
		: false;

	if (isLoading) {
		return (
			<Container maxWidth="sm" sx={{ mt: 8 }}>
				<LinearProgress />
				<Typography align="center" sx={{ mt: 2 }}>
					Loading submission...
				</Typography>
			</Container>
		);
	}

	if (isError) {
		const requestError = error as { status?: number };
		const expired = requestError.status === 410;

		return (
			<Container maxWidth="sm" sx={{ mt: 8 }}>
				<Alert severity="error">
					{expired
						? 'This questionnaire link has expired. Please contact AusRehab to request a new link.'
						: 'Unable to load this submission confirmation. The link may be invalid.'}
				</Alert>
			</Container>
		);
	}

	if (!justSubmitted && !data?.submittedAt) {
		return <Navigate to={`/questionnaire/fill/${token}`} replace />;
	}

	return (
		<>
			<Helmet>
				<title>Questionnaire Submitted - {process.env.REACT_APP_ORG}</title>
			</Helmet>
			<Container maxWidth="sm" sx={{ mt: 6, mb: 8 }}>
				<Paper variant="outlined" sx={{ p: 4 }}>
					<Stack spacing={3} alignItems="flex-start">
						<Alert severity="success" icon={<CheckCircleOutlineIcon fontSize="inherit" />} sx={{ width: '100%' }}>
							Your questionnaire has been submitted successfully.
						</Alert>
						<div>
							<Typography variant="h4" gutterBottom>
								Thank you
							</Typography>
							<Typography color="text.secondary">
								We have received your pre-employment questionnaire. If you need to review or update your answers,
								use the same secure link. You can also close this page now.
							</Typography>
						</div>
						<Button variant="outlined" onClick={() => navigate(`/questionnaire/fill/${token}`)}>
							Review answers
						</Button>
					</Stack>
				</Paper>
			</Container>
		</>
	);
}
